/* import __COLOCATED_TEMPLATE__ from './left-nav.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import storage from 'embercom/vendor/intercom/storage';

interface Signature {
  Args: {};
}

export default class WorkforceLeftNav extends Component<Signature> {
  @service declare appService: AppService;

  @tracked configureOpen: boolean;

  get showSchedulingRules(): boolean {
    return this.appService.app.canUseFeature('wfm-scheduling-rules');
  }

  get showTimeOffRequests(): boolean {
    return this.appService.app.canUseFeature('wfm-workday-integration');
  }

  private get storageKey(): string {
    return `workforce.left-nav.configure-${this.appService.app.id}`;
  }

  constructor(owner: unknown, args: Record<string, never>) {
    super(owner, args);
    let stored = storage.get(this.storageKey);
    this.configureOpen = stored === null ? true : stored === true;
  }

  @action
  toggleConfigure(): void {
    this.configureOpen = !this.configureOpen;
    storage.set(this.storageKey, this.configureOpen);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workforce::LeftNav': typeof WorkforceLeftNav;
    'workforce/left-nav': typeof WorkforceLeftNav;
  }
}
